function AppNotFound() {
  return <div>Not Found</div>;
}

export default AppNotFound;
